import http from "@/http-common";
import './security';

class BitacoraService {
  getAll() {
    return http.get("/debug/logs");
  }

  create(data) {
    return http.post("/debug/logs", data);
  }

  write(type, message) {
    var data = {
      level: type,
      message: message,
    };

    this.create(data)
  }

  deleteAll() {
    return http.delete("/debug/logs");
  }
}

export default new BitacoraService();
